import axios from "axios";


const api = axios.create({
    baseURL: process.env.REACT_APP_API_INSTAGRAM_URI
});

api.interceptors.request.use(async config => {

    // config.headers.Authorization = `Bearer ${process.env.REACT_APP_API_INSTAGRAM_TOKEN}`;

    return config;
});

export default api;